<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import AnfrageService from "@/businesslogic/services/AnfrageService";
import { useRouter } from "vue-router";
import Logger from "js-logger";
import Modal from "@/components/Modal.vue";
import GevFooter from "@/layout/GevFooter.vue";
import GevHeader from "@/layout/GevHeader.vue";
import storeUtils from "@/businesslogic/utils/storeUtils";
import dateUtils from "@/businesslogic/utils/dateUtils";
import { v4 as uuidv4 } from "uuid";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "Wiederaufnahme",
  props: {
    sparte: String,
    anfrageId: String,
    quelle: String,
  },
  components: {
    GevFooter,
    GevHeader,
    Modal,
  },
  setup(props) {
    const piniaStore = useFormStore();
    const { istFhkVerkaufsprodukt } = storeUtils();
    const { dateStringToIsoDate, getIsoDateNow } = dateUtils();
    const router = useRouter();
    const zeigeHinweis = ref(false);
    const weiterZuNeu = () => {
      zeigeHinweis.value = !zeigeHinweis.value;
      beginneNeu();
    };

    const decodeProduktId = (produktId: string) => {
      switch (produktId) {
        case "K323000G0000":
          return "phv";
        case "P4G3000G0000":
          return "phv2025";
        case "6S23000G0000":
          return "hug";
        case "0S42000G0000":
        case "HW63000G0000":
          return "vgv";
        case "RJU0000G0000":
          return "bl";
        case "0LI0000G0000":
          return "bh";
        case "7CF3000G0000":
          return "vhv2024";
        default:
          throw new Error("Die Produkt-ID konnte nicht ermittelt werden.");
      }
    };

    const forward = (sparte: string) => {
      switch (sparte) {
        case "phv":
          router.push("/phv2020/");
          break;
        case "phv2025":
          router.push("/phv/");
          break;
        case "hug":
          router.push("/hug/");
          break;
        case "vgv":
          router.push("/vgv/");
          break;
        case "bl":
          router.push("/bl/");
          break;
        case "bh":
          router.push("/bh/");
          break;
        case "vhv2024":
          router.push("/vhv/");
          break;
        case "fh2024":
          router.push("/fh/");
          break;
        default:
          throw new Error("Die Sparte konnte nicht ermittelt werden.");
      }
    };

    const beginneNeu = () => {
      if (props.sparte) {
        let sparte = props.sparte;
        if ("phv" === props.sparte) {
          sparte = "phv2025";
        }
        piniaStore.storeInitialisiereStandard(piniaStore.state, sparte, false, false);
        forward(sparte);
      }
    };

    function bindungsfristIstAbgelaufen(data: any) {
      const bindungsfristInMonaten = 3;
      const erstelldatum = dateStringToIsoDate(data.erstelldatum);
      const ablaufdatum = new Date(erstelldatum.setMonth(erstelldatum.getMonth() + bindungsfristInMonaten));
      const heute = dateStringToIsoDate(getIsoDateNow());
      return heute > ablaufdatum;
    }

    const vorschlagWiederherstellen = () => {
      if (props.anfrageId) {
        Logger.trace("Ein existierender Vorschlag wird vom Backend abgeholt");
        AnfrageService.laden(
          piniaStore.getSessionToken(undefined),
          false,
          props.sparte,
          props.anfrageId,
          props.quelle,
          "Wiederaufnahme",
        )
          .then((res) => {
            if (res.status == 204) {
              beginneNeu();
            } else if (res.status != 200) {
              throw new Error(res.statusText);
            }
            return res.data;
          })
          .then((data) => {
            if (data) {
              if (data.status !== "NEU") {
                beginneNeu();
              } else if ("phv" === props.sparte && bindungsfristIstAbgelaufen(data)) {
                zeigeHinweis.value = true;
              } else {
                piniaStore.setStateData(data);
                if (piniaStore.state.sessionId === undefined || piniaStore.state.sessionId === "") {
                  piniaStore.state.sessionId = uuidv4();
                }
                if (istFhkVerkaufsprodukt(data)) {
                  forward("fh2024");
                } else {
                  forward(decodeProduktId(data.tarifinformationen.produktId));
                }
              }
            }
          });
      }
    };

    onMounted(() => {
      vorschlagWiederherstellen();
    });

    return {
      zeigeHinweis,
      weiterZuNeu,
    };
  },
});
</script>

<template>
  <div id="page">
    <gev-header />
    <main class="o-container u-pad-y-0 js-main-container u-bg-white" style="position: relative">
      <div style="height: 70vh">&nbsp;</div>

      <modal v-if="zeigeHinweis" titel="Neuer Privathaftpflichttarif" @closeModal="weiterZuNeu">
        <template v-slot:inhalt>
          Wir haben einen neuen Tarif. Ihr vorliegender Vorschlag ist leider nicht mehr gültig. Sie können hier ein
          neues Angebot berechnen.
        </template>
      </modal>
    </main>
    <gev-footer />
  </div>
</template>
